<template>
    <div id="app">
        <navigation :links="links" v-if="authenticated"></navigation>
        <div v-if="!loading" class="app-body">
            <router-view />
        </div>

        <loading :active.sync="loading" :is-full-page="true"/>

        <the-toaster />
    </div>
</template>

<script>
import { mapState } from 'pinia';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { useRootStore } from './stores/root';
import Navigation from "./components/Navigation";
import TheToaster from './components/toaster/TheToaster.vue';

export default {
    name: "App",

    components: {
        Navigation,
        Loading,
        TheToaster
    },

    computed: {
        links() {
            return [ 
                { route: '/dashboard', placeholder: this.$t('links.dashboard'), faIcon: 'fas fa-th-large' },
                { route: '/users', placeholder: this.$t('links.users'), faIcon: 'fas fa-users', privileges: [ 'admin'] },
                { route: '/documents', placeholder: this.$t('links.documents'), faIcon: 'fas fa-file-alt', privileges: ['admin'] },
                { route: '/situations', placeholder: this.$t('links.situations'), faIcon: 'fas fa-cube', privileges: ['admin'] },
                { route: '/games', placeholder: this.$t('links.games'), faIcon: 'fas fa-dice', privileges: ['lecturer'] }
            ];
        },
        
        ...mapState(useRootStore, ["loading", "authenticated", "user"]),
    }
}
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}

#app {
    position: relative;
    display: flex;
    width: 100%;
    height: 100vh;

    flex-direction: column;
}

#app .navigation {
    height: 50px;
}

#app .app-body {
    flex: 1;
    background-color: #f2f2f2;
}

#app .loading {
    position: fixed;

    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.75);
}

.loading .loading-text {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 2.5rem;
    color: rgba(255, 255, 255, 0.5);
}
</style>
